"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
class CallControlController {
    constructor($scope, $timeout, XucPhoneState, applicationConfiguration, CtiProxy, keyboard, processVolume, $rootScope, audioQualityStatistics, XucPhoneEventListener, JitsiProxy, incomingCall, onHold) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.XucPhoneState = XucPhoneState;
        this.applicationConfiguration = applicationConfiguration;
        this.CtiProxy = CtiProxy;
        this.keyboard = keyboard;
        this.processVolume = processVolume;
        this.$rootScope = $rootScope;
        this.audioQualityStatistics = audioQualityStatistics;
        this.XucPhoneEventListener = XucPhoneEventListener;
        this.JitsiProxy = JitsiProxy;
        this.incomingCall = incomingCall;
        this.onHold = onHold;
        this.dynamicTranslation = { phoneNb: undefined };
        this.startAudioQualityMonitoring = (call) => {
            this.audioQualityStatistics.startAudioQualityMonitoring(call.userData.SIPCALLID);
        };
        this.stopAudioQualityMonitoring = (call) => {
            if (call)
                this.audioQualityStatistics.stopAudioQualityMonitoring(call.userData.SIPCALLID);
            this.audioQuality = undefined;
        };
        this.isWebRtcActive = () => {
            return this.CtiProxy.isUsingWebRtc();
        };
        this.removeCallPlaceholder = (showError = false) => {
            this.callInitError = showError;
            this.callPlaceholderDisplayed = false;
            this.cancelPlaceholderTimeout();
        };
        this.displayCallPlaceholder = () => {
            this.callPlaceholderDisplayed = true;
            this.placeholderTimeout = this.$timeout(this.removeCallPlaceholder.bind(null, true), 5000);
        };
        this.cancelPlaceholderTimeout = () => {
            if (this.placeholderTimeout != undefined) {
                this.$timeout.cancel(this.placeholderTimeout);
                this.placeholderTimeout = undefined;
            }
        };
        this.removeAudioQualityError = () => {
            this.displayAudioQuality = false;
        };
        this.clearAudioQualityTimeout = () => {
            if (this.audioQualityTimeout) {
                this.$timeout.cancel(this.audioQualityTimeout);
                this.audioQualityTimeout = undefined;
            }
        };
        this.enableAudioQualityError = () => {
            this.displayAudioQuality = true;
        };
        this.audioQualityClass = () => {
            if (this.audioQuality == this.audioQualityStatistics.AUDIO_QUALITY_GOOD)
                return 'good-quality';
            else if (this.audioQuality == this.audioQualityStatistics.AUDIO_QUALITY_MEDIUM)
                return 'medium-quality';
            else if (this.audioQuality == this.audioQualityStatistics.AUDIO_QUALITY_BAD)
                return 'bad-quality';
            else
                return '';
        };
        this.displayAudioQualityIssue = () => {
            return this.displayAudioQuality;
        };
        this.hold = (uniqueId) => {
            this.isMuted = false;
            this.CtiProxy.hold(uniqueId);
        };
        this.isSecondCallAndIsYealink = () => {
            return this.calls.length > 1 && this.CtiProxy.getDeviceVendor() === 'Yealink';
        };
        this.hangup = (uniqueId) => {
            this.CtiProxy.hangup(uniqueId);
        };
        this.answer = (uniqueId) => {
            if (this.JitsiProxy.videoIsOngoing())
                this.JitsiProxy.muteMicrophoneInJitsi();
            this.CtiProxy.answer(uniqueId);
        };
        this.isConferenceCall = (call) => {
            return call.conference !== undefined;
        };
        this.hasConferenceCall = () => {
            return this.calls.find(call => this.isConferenceCall(call)) !== undefined;
        };
        this.hasCall = () => {
            return this.calls.find(call => !this.isConferenceCall(call)) !== undefined;
        };
        this.makeConference = () => {
            this.CtiProxy.conference();
        };
        this.displayMakeConferenceButton = () => {
            return this.calls.length > 1 && this.isConferenceCapable() && this.calls.every(call => !this.isConferenceCall(call));
        };
        this.closeCallInitError = () => {
            this.callInitError = false;
        };
        this.closeVideoInitError = () => {
            this.videoInitError = undefined;
        };
        this.displayCallInitError = () => {
            return this.callInitError;
        };
        this.transfer = () => {
            this.CtiProxy.completeTransfer();
        };
        this.toggleMicrophone = (call) => {
            if (call.conference) {
                this.isMuted ? this.conferenceUnmuteMe(call.conference.conferenceNumber) : this.conferenceMuteMe(call.conference.conferenceNumber);
            }
            else {
                this.CtiProxy.toggleMicrophone(call.uniqueId);
                this.isMuted = !this.isMuted;
            }
        };
        this.includeCallToConference = () => {
            this.CtiProxy.includeToConference();
        };
        this.displayIncludeCallToConferenceButton = () => {
            return this.calls.length > 1 && this.hasConferenceCall() && this.hasCall();
        };
        this.displayTransferButton = () => {
            return (this.calls.length === 2 && this.calls.every(call => !this.isConferenceCall(call)));
        };
        this.conferenceMuteMe = (conferenceNumber) => {
            this.CtiProxy.conferenceMuteMe(conferenceNumber);
            this.isMuted = true;
        };
        this.conferenceUnmuteMe = (conferenceNumber) => {
            this.CtiProxy.conferenceUnmuteMe(conferenceNumber);
            this.isMuted = false;
        };
        this.conferenceMuteAll = (conferenceNumber) => {
            this.CtiProxy.conferenceMuteAll(conferenceNumber);
        };
        this.conferenceUnmuteAll = (conferenceNumber) => {
            this.CtiProxy.conferenceUnmuteAll(conferenceNumber);
        };
        this.conferenceMute = (conferenceNumber, index) => {
            this.CtiProxy.conferenceMute(conferenceNumber, index);
        };
        this.conferenceUnmute = (conferenceNumber, index) => {
            this.CtiProxy.conferenceUnmute(conferenceNumber, index);
        };
        this.conferenceKick = (conferenceNumber, participant) => {
            participant.kicked = true;
            this.CtiProxy.conferenceKick(conferenceNumber, participant.index);
        };
        this.canMuteAll = (conference) => {
            if (conference.currentUserRole == 'Organizer') {
                var nbUnmuted = lodash_1.default.filter(conference.participants, { 'isMe': false, 'isMuted': false }).length;
                if (nbUnmuted > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        };
        this.canUnmuteAll = (conference) => {
            if (conference.currentUserRole == 'Organizer' && !this.canMuteAll(conference)) {
                var nbMuted = lodash_1.default.filter(conference.participants, { 'isMe': false, 'isMuted': true }).length;
                if (nbMuted > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        };
        this.displayParticipantActions = (conference, participant) => {
            if (!participant.kicked && (participant.isMe || conference.currentUserRole == 'Organizer')) {
                return true;
            }
            else {
                return false;
            }
        };
        this.faClassFromState = (state) => {
            switch (state) {
                case this.XucPhoneState.STATE_RINGING:
                case this.XucPhoneState.STATE_DIALING:
                    return "fa-spinner fa-pulse fa-fw";
                case this.XucPhoneState.STATE_ONHOLD:
                    return "xivo-pause-appel call-on-hold";
            }
            return "fa-exclamation-triangle";
        };
        this.isConferenceCapable = () => {
            return this.CtiProxy.isConferenceCapable();
        };
        this.showKeyboard = () => {
            this.keyboard.show();
        };
        this.canChat = (call, username) => {
            return (call.state === 'Established' || call.state === 'OnHold') && username != undefined;
        };
        this.isConferenceAndIsMuted = (uniqueId) => {
            return this.XucPhoneState.isConferenceAndIsMuted(uniqueId);
        };
        this.displayMicrophoneError = () => {
            if (this.disableMicrophoneBrokenMessage)
                return false;
            return this.microphoneIsBroken;
        };
        this.disableMicrophoneError = () => {
            this.disableMicrophoneBrokenMessage = true;
        };
        this.muteWebRtcUser = (call) => {
            if (this.isWebRtcActive() && call.state === 'Established' && !call.conference) {
                return true;
            }
            else {
                return false;
            }
        };
        this.conferenceUndeaf = (conferenceNumber, participantIndex) => {
            this.CtiProxy.conferenceUndeafen(conferenceNumber, participantIndex);
        };
        this.audioQualityTimeoutMS = 15000;
        this.displayAudioQuality = false;
        this.appConfig = this.applicationConfiguration.getCurrentAppConfig();
        this.calls = XucPhoneState.getCalls();
        this.conference = XucPhoneState.getDeviceConference();
        this.isMuted = false;
        this.microphoneIsBroken = false;
        this.disableMicrophoneBrokenMessage = false;
        this.callPlaceholderDisplayed = false;
        this.callInitError = false;
        this.JitsiProxy.subscribeToStartVideoError(this.$scope, (event, error) => {
            this.videoInitError = error;
        });
        this.$scope.$watchCollection(() => { return this.calls; }, (newVal) => {
            if (newVal === undefined || newVal.length === 0) {
                this.isMuted = false;
                this.disableMicrophoneBrokenMessage = false;
                this.microphoneIsBroken = false;
                this.removeAudioQualityError();
                this.clearAudioQualityTimeout();
            }
            this.removeCallPlaceholder();
            this.cancelPlaceholderTimeout();
        });
        this.$rootScope.$on('EventShowCallPlaceHolder', this.displayCallPlaceholder);
        if (this.isWebRtcActive()) {
            this.XucPhoneEventListener.addEstablishedHandler(this.$scope, this.startAudioQualityMonitoring);
            this.XucPhoneEventListener.addReleasedHandler(this.$scope, this.stopAudioQualityMonitoring);
            this.$scope.$on(audioQualityStatistics.AUDIO_QUALITY_EVENT, (event, data) => {
                if (this.audioQuality == audioQualityStatistics.AUDIO_QUALITY_MEDIUM || this.audioQuality == audioQualityStatistics.AUDIO_QUALITY_BAD) {
                    if (data.quality == audioQualityStatistics.AUDIO_QUALITY_GOOD && !this.audioQualityTimeout) {
                        this.audioQualityTimeout = $timeout(this.removeAudioQualityError, this.audioQualityTimeoutMS);
                    }
                }
                if (data.quality == audioQualityStatistics.AUDIO_QUALITY_MEDIUM || data.quality == audioQualityStatistics.AUDIO_QUALITY_BAD) {
                    this.enableAudioQualityError();
                    this.clearAudioQualityTimeout();
                }
                this.audioQuality = data.quality;
                this.statistics = data.statistics;
            });
        }
        this.$scope.$on('dialingNumber', (e, data) => {
            this.closeCallInitError();
            this.dynamicTranslation.phoneNb = data;
        });
        this.$rootScope.$on(this.processVolume.EVENT_INPUT_ACTIVE, (event, data) => {
            this.microphoneIsBroken = !data;
            if (data == true)
                this.disableMicrophoneBrokenMessage = true;
        });
    }
}
exports.default = CallControlController;
CallControlController.$inject = ["$scope", "$timeout", "XucPhoneState", "applicationConfiguration",
    "CtiProxy", "keyboard", "processVolume", "$rootScope", "audioQualityStatistics",
    "XucPhoneEventListener", "JitsiProxy", "incomingCall", "onHold"];
